import "./App.css";
import Home from "./pages/Home";
import React, { lazy, Suspense } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Loading from "./components/shared/Loading";
import StudentHistory from "./pages/dashboard/StudentHistory";
import StudentCourse from "./pages/dashboard/StudentCourse";
import FloatingButton from "./components/shared/FloatingButton";
import Downloader from "./components/shared/Downloader";
import Ott from "./pages/Ott";
const Gallery = lazy(() => import("./pages/Gallery"));
const RootLayout = lazy(() => import("./layouts/RootLayout"));
const DynamicPage = lazy(() => import("./pages/DynamicPage"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const EMagazine = lazy(() => import("./pages/EMagazine"));
const Contact = lazy(() => import("./pages/Contact"));
const NotFound = lazy(() => import("./components/shared/NotFound"));
const CourseDetail = lazy(() => import("./pages/CourseDetails"));
const Flipbook = lazy(() => import("./pages/Flipbook"));
const StudentDashboard = lazy(
  () => import("./pages/dashboard/StudentDashboard")
);
const DashboardLayout = lazy(() => import("./layouts/DashboardLayout"));
const Download = lazy(() => import("./pages/Download"));
const Courses = lazy(() => import("./pages/Courses"));
const VerifyOTP = lazy(() => import("./pages/VerifyOTP"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const StudentProfile = lazy(() => import("./pages/dashboard/StudentProfile"));
const StudentReview = lazy(() => import("./pages/dashboard/StudentReview"));
const AuthGuard = lazy(() => import("./guards/AuthGuard"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const StudentWishList = lazy(() => import("./pages/dashboard/StudentWishList"));
const StudentSetting = lazy(() => import("./pages/dashboard/StudentSetting"));
const JSLoader = lazy(() => import("./components/shared/JSLoader"));
const NotAuthGuard = lazy(() => import("./guards/NotAuthGuard"));

function App() {
  return (
    <>
      <Suspense fallback={<Loading />}>
        <Router>
          <FloatingButton />
          <Routes>
            <Route path="/" element={<RootLayout />}>
              <Route index element={<Home />} />
              <Route
                path="login"
                element={
                  <NotAuthGuard>
                    <Login />
                  </NotAuthGuard>
                }
              />
              <Route path="registration" element={<Register />} />
              <Route path="e-magazine" element={<EMagazine />} />
              <Route path="contact" element={<Contact />} />
              <Route path="downloads" element={<Download />} />
              <Route path="404" element={<NotFound />} />
              <Route path="courses" element={<Courses />} />
              <Route path="gallery" element={<Gallery />} />
              <Route
                path="creative-warriors-course-detail/:id"
                element={<CourseDetail />}
              />
              <Route path="forgotpassword" element={<ForgotPassword />} />
              <Route path="verify" element={<VerifyOTP />} />
              <Route path="flipbook/:name" element={<Flipbook />} />
              <Route path="reset-password" element={<ResetPassword />} />
              <Route path="wp-content/uploads/*" element={<Downloader />} />
              <Route path="ott" element={<Ott />} />
              <Route path="*" element={<DynamicPage />} />
            </Route>
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route
                index
                element={
                  <AuthGuard>
                    <StudentDashboard />
                  </AuthGuard>
                }
              />
              <Route
                path="student-profile"
                element={
                  <AuthGuard>
                    <StudentProfile />
                  </AuthGuard>
                }
              />
              <Route
                path="student-setting"
                element={
                  <AuthGuard>
                    <StudentSetting />
                  </AuthGuard>
                }
              />
              <Route
                path="student-review"
                element={
                  <AuthGuard>
                    <StudentReview />
                  </AuthGuard>
                }
              />

              <Route
                path="student-settings"
                element={
                  <AuthGuard>
                    <StudentSetting />
                  </AuthGuard>
                }
              />
              <Route
                path="student-wishlist"
                element={
                  <AuthGuard>
                    <StudentWishList />
                  </AuthGuard>
                }
              />
              <Route
                path="student-history"
                element={
                  <AuthGuard>
                    <StudentHistory />
                  </AuthGuard>
                }
              />
              <Route
                path="student-enrolled-courses"
                element={
                  <AuthGuard>
                    <StudentCourse />
                  </AuthGuard>
                }
              />
            </Route>
          </Routes>
          <JSLoader />
        </Router>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              borderRadius: "10px",
              color: "#000",
              fontSize: "15px",
              padding: "10px",
            },
            duration: 6000,
          }}
        />
      </Suspense>
    </>
  );
}

export default App;
